import { Routes } from "@angular/router";
import { WorkflowEndcustomerOneTariffOrderCancelComponent } from "./workflow-endcustomer-one-tariff-order-cancel.component";

export const WorkflowEndcustomerOneTariffOrderCancelRouting: Routes = [
    {
        path: 'change-tariff/:aid/order-cancel', component: WorkflowEndcustomerOneTariffOrderCancelComponent
    },
]
